import React from 'react'
import { useLocation } from 'react-router-dom';
import { navItems, callItems, programItems, yearItems, dropItems } from '../../common/constants/navItems'
import NavItem from './components/NavItem/NavItem'
import { YearItem, DropdownItem } from './components/DropdownItem/DropdownItem'
import './NavBar.scss'

const NavBar = () => {
  const year = useLocation().pathname.split('/')[1]
  yearItems[0].dropdown = 'Year (' + year + ')'
  // Before redirecting, year may be null string or another string that
  // is not equal to those in yearItems[0].items
  if (year && yearItems[0].items.includes(year)) {
    return (
      <div className="col-8 col-md-3">
        <nav className="nav flex-column">
         {yearItems.map(item => <YearItem {...item} /> )}
          {dropItems[year].map(item => <DropdownItem {...item} /> )}
          {callItems[year].map(item => <DropdownItem {...item} /> )}
          {programItems[year].map(item => <DropdownItem {...item} /> )}
          {navItems.map(item => <NavItem>{item}</NavItem>)}
        </nav>
      </div>
    )
  } else {
    return (
      <div className="col-8 col-md-3">
        <nav className="nav flex-column">
          {yearItems.map(item => <YearItem {...item} /> )}
          {navItems.map(item => <NavItem>{item}</NavItem>)}
        </nav>
      </div>
    )
  }

}

export default NavBar



